import { HttpService } from 'src/app/http.service';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-business-type-wise-product-commission-edit',
  templateUrl: './business-type-wise-product-commission-edit.component.html',
  styleUrls: ['./business-type-wise-product-commission-edit.component.scss']
})
export class BusinessTypeWiseProductCommissionEditComponent {
  commssion: number = null;
  product_id: number = null;
  business_type_id: number = null;
  products = {};
  business_types = {};

  constructor(
    public dialogRef: MatDialogRef<BusinessTypeWiseProductCommissionEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private http: HttpService) {
    console.log(data);
    this.commssion = data['commission'];
    this.business_type_id = data['business_type_id'];
    this.product_id = data['product_id'];
    this.getProductsNameDictType();
  }

  updateCommission(new_commission: number) {
    const commission_data = {
      commission: new_commission,
      product_id: this.product_id,
      business_type_id: this.business_type_id
    };

    this.http.saveOrUpdateBusinssTypeWiseProductCommission(commission_data).subscribe((data) => {
      console.log(data);
      const updated_data = {
        commission: new_commission,
        product_id: this.product_id,
        business_type_id: this.business_type_id
      };
      this.closeComponent(updated_data);
    });

  }

  getProductsNameDictType() {
    this.http.getProductsNameDictType().subscribe((data) => {
      console.log(data);
      this.products = data;
    }, (error) => {
        console.log(error);
    });
  }

  getBusinessTypeNameDictType() {
    this.http.getBusinessTypeNameDictType().subscribe((data) => {
      console.log(data);
      this.business_types = data;
    }, (error) => {
        console.log(error);
    });
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }
}


interface DialogData {
  product_id: number;
  business_type_id: number;
  commission: number;
}

